import { Shape, Vector2 } from "three";
// eslint-disable-next-line boundaries/element-types
import { getShapeBounds } from "./getShapeBounds";
export function scaleShape(shape, width) {
    const shapePoints = shape.getPoints();
    const bounds = getShapeBounds(shape);
    const size = bounds.getSize(new Vector2());
    const scale = width / size.x; // Y scale factor and X scale factor are the same, to preserve aspect ratio
    // scale according to the above calculations.
    // Note, this scaling does not take into account holes or curves; only works for simple polygons.
    shapePoints.map((p) => p.multiplyScalar(scale));
    return new Shape(shapePoints);
}
//# sourceMappingURL=scaleShape.js.map